import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import _ from 'lodash'
import { numberFormat } from 'utils/app.utils'

async function ExportToExcel({
    data,
    branchName,
    t,
}: {
    data: any[]
    branchName: string
    t: any
}) {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet(t('REPORT.REPORT_NAME.ADVANCE_BALANCE'))

    // Title
    const titleRow = sheet.addRow([t('REPORT.REPORT_NAME.ADVANCE_BALANCE')])
    titleRow.font = { bold: true, size: 16 }
    sheet.mergeCells(titleRow.number, 1, titleRow.number, 6)
    titleRow.alignment = { horizontal: 'left' }

    // Branch name
    const branchRow = sheet.addRow([`${t('REPORT.TABLE.DECREASE.BRANCH')}: ${branchName || '-'}`])
    branchRow.font = { size: 11 }
    sheet.mergeCells(branchRow.number, 1, branchRow.number, 6)
    branchRow.alignment = { horizontal: 'left' }

    // Head cells (from BalanceList)
    const headCells = [
        { label: t('REPORT.TABLE.DF.#NO'), width: 10 },
        { label: t('REPORT.TABLE.CN_NUMBER'), width: 20 },
        { label: t('REPORT.TABLE.BRANCH_CN_NUMBER'), width: 20 },
        { label: t('REPORT.TABLE.SN_CODE'), width: 20 },
        { label: t('REPORT.TABLE.PATIENT_NAME'), width: 25 },
        { label: t('REPORT.TABLE.ADVANCE.ADVANCE_BALANCE'), width: 20 },
    ]
    sheet.columns = headCells.map(c => ({ width: c.width }))
    const headerRow = sheet.addRow(headCells.map(c => c.label))
    headerRow.font = { bold: true, size: 12 }
    headerRow.alignment = { horizontal: 'left', vertical: 'middle' }

    // Data rows
    if (!data || data.length === 0) {
        const noDataRow = sheet.addRow([t('REPORT.TITLE.NO_DATA')])
        sheet.mergeCells(noDataRow.number, 1, noDataRow.number, headCells.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
    } else {
        data.forEach((row: any, idx: number) => {
            sheet.addRow([
                idx + 1,
                row.cnNumber || '-',
                row.branchCnNumber || '-',
                row.snCode || '-',
                row.patientFullname || '-',
                numberFormat(row.advanceBalance, 2),
            ])
        })
        // Summary row (sum columns)
        const sumRow = sheet.addRow([
            '', '', '', '', t('REPORT.TITLE.SUM'),
            numberFormat(_.sumBy(data, 'advanceBalance') || 0, 2),
        ])
        sumRow.font = { bold: true }
        sumRow.alignment = { horizontal: 'right' }
        sheet.mergeCells(sumRow.number, 1, sumRow.number, 5)
    }

    // Save file
    const buffer = await workbook.xlsx.writeBuffer()
    const timestamp = new Date().toISOString().replace(/[-:T.]/g, '').slice(0, 14)
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `${t('REPORT.REPORT_NAME.ADVANCE_BALANCE')}_${timestamp}.xlsx`)
}

export default ExportToExcel 